import type { DonutChartProps } from '@mantine/charts'
import { DonutChart as MantineDonutChart } from '@mantine/charts'

export function BudgetDonutChart({ data }: DonutChartProps) {
  return (
    <MantineDonutChart
      data={data}
      mx="auto"
      size={48}
      strokeWidth={0}
      thickness={6}
      withTooltip={false}
    />
  )
}
